module.exports = __webpack_public_path__ + "static/media/aib.fa5edd43.png";